import * as React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Form } from 'react-final-form';
import cn from 'classnames';
import Field from './Field/Field';
import { useTheme } from '../../../../../theme';
import { getOrder } from '../../../../../Checkout/store/order/selectors';
import InfoLinksLabel from '../../../../../InfoLinksLabel';
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import { BaseButton } from '../../../../../BaseComponents';
const CreateRequest = ({ className, header, description, buttonText, send, initialValues, isSending, autoMode, isRulesOptional }) => {
    const theme = useTheme('Exchange').CreateRequest;
    const { t } = useTranslation('Exchange');
    const order = useSelector(getOrder);
    const onSubmitHandler = (values) => {
        send(values).then(data => { });
    };
    const formValues = Object.assign({}, initialValues);
    // for correct validation of the phone number
    if (formValues.phone &&
        formValues.phone.startsWith('7') &&
        formValues.phone.replace(/\(|\)\s/, '').length === 11 &&
        parsePhoneNumberFromString(formValues.phone, 'RU')) {
        formValues.phone = `+${formValues.phone}`;
    }
    if (!formValues.phone.startsWith('+')) {
        formValues.phone = `+${formValues.phone}`;
    }
    return (React.createElement(Form, { onSubmit: onSubmitHandler, initialValues: formValues }, ({ handleSubmit }) => (React.createElement("form", { onSubmit: handleSubmit },
        React.createElement("div", { className: cn(theme.container, className) },
            React.createElement("div", { className: theme.header }, header !== null && header !== void 0 ? header : t('Create request'),
                description && React.createElement("div", { className: theme.description }, description)),
            React.createElement("div", { className: cn(theme.row, theme.main) },
                React.createElement(Field, { name: "name", type: "text", label: t('Your name'), className: theme.field }),
                React.createElement(Field, { name: "email", type: "email", label: t('Email'), className: theme.field }),
                React.createElement(Field, { name: "phone", type: "phone", label: t('Your phone'), className: theme.field, displayInitialValueAsLocalNumber: false })),
            React.createElement("div", { className: cn(theme.row) },
                React.createElement(Field, { name: "comment", type: "comment", label: t('Your comment'), className: cn(theme.field, theme.field_comment), required: !autoMode }))),
        React.createElement("div", { className: theme.controls },
            !isRulesOptional && (React.createElement(Field, { name: "acceptTerm", type: "checkbox", label: React.createElement(InfoLinksLabel, { className: theme.label, order: order, type: 'exchange' }) })),
            React.createElement(BaseButton, { variant: "action", type: "submit", className: theme.submit, isLoading: isSending, "data-next-button": true }, buttonText !== null && buttonText !== void 0 ? buttonText : t('Create request')))))));
};
export default CreateRequest;
